<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle"></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img :src="img" alt="Circle Image" class="img-raised rounded-circle img-fluid"/>
                </div>
                <div class="name">
                  <h3 class="title">Lucas Selliach</h3>
                  <h6>WEB SOFTWARE DEVELOPER</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              I'm a web developer with bachelor degree on computer science at UNIVALI, a university based in Itajaí (Brazil), class of 2013. By being in love with what I do. I'm always seeking for more knowledge to improve my skills and overcome challenges. In 2008 started programming ASP.NET, a platform which gave me a lot of learning. After, I joined FRONTEND development where I discovered a new passion. Nowadays, I'm a specialist on web development in .net core and angular, and my main focus is back architecture development.
            </p>
          </div>
          <div class="profile-tabs">
            <tabs
              :tab-name="['Knowledge', 'Certificate', 'Projects']"
              :tab-icon="['portrait', 'school', 'code']"
              plain
              nav-pills-icons
              color-button="success"
            >
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <h3>Front-end</h3>
                    <P> 
                      HTML5, CSS3, JS, ANGULAR (RxJS, NgRx), Css Frameworks Notions (Bootstrap, Materialize and others), general knowledge in NPM, HTTP, HTTPS, CORS. CSP, Tests (Karma, Jasmine) and TypeScript.
                    </P>
                    </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <h3>Back-end</h3>
                    <P> C#, .net Core, Git, common RDB (MySql, Sql Server, Postgre), ORM, NoSql (Raven, Mongo), API general knowledge (Swagger, Json, Authentication - Cookie, Oauth, Basic, Token and JWT), Caching (Redis server side), General web security knowledge (Hashing Algorithms, HTTPS, CORS, SSL/TLS), Test (Unit in core), General Architectural Patterns (Monolithic code friendly, MicroServices, Ports/Adapters, CQRS with Event Sourcing, UOW), Design and Development Principles (GOF, DDD, TDD, SOLID, KISS, YAGNI, DRY), experience with Message Brokers (RabbitMQ) and Search Engines (Elasticsearch). Scrum skill</P>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Diploma 01.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Diploma 02.png" alt="">
                    </login-card>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 02.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 03.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 04.png" alt="">
                    </login-card>
                  </div>
                </div>   
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 05.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 06.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 09.png" alt="">
                    </login-card>
                  </div>
                </div>   
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 07.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 08.png" alt="">
                    </login-card>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 11.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 01.png" alt="">
                    </login-card>
                  </div>
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 10.png" alt="">
                    </login-card>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <img slot="media" src="../assets/imgnew/Cert/Cert 12.png" alt="">
                    </login-card>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 mc-auto">
                    <login-card header-color="green">
                      <h4 slot="title" class="title">SGW Project</h4>
                      <h5 slot="subhead" class="md-subhead">This is a project example of booking and accommodation made using asp.core with angular 6, bootstrap and dedication. To test, you can use the follows credentials. <br> EMAIL: "pedrohenriqueguilhermearao-86@oi.com.br" PASSWORD: "123456" </h5>
                      <img slot="media" src="../assets/imgnew/sgwproject.png" alt="">
                      <div slot="footer" class="md-block">
                        <md-button class="md-success md-sm" href="https://sgwhotel.azurewebsites.net/" > 
                          Project Link
                        </md-button>
                      </div>
                    </login-card>
                  </div>
                  
                </div>                
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
import { LoginCard } from '@/components'

export default {
  components: {
    Tabs,
    LoginCard
  },
  bodyClass: "profile-page",
  data() {
    return {
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/imgnew/city-profile2.png")
    },
    img: {
      type: String,
      default: require("@/assets/imgnew/marc3.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
